export default __webpack_public_path__ + "static/media/QuickWinsWithEdit.b9733e06.png";